import { fetch, buildUrl } from 'domain/Api';
import {
  fetchStudentReportSummaryIfNeeded,
} from '../StudentReportSummaries/actions';
import { ApiCall } from 'omni-common-ui';

export const APPROVE_STUDENT_REPORT_REQUEST = 'APPROVE_STUDENT_REPORT_REQUEST';
export const APPROVE_STUDENT_REPORT_SUCCESS = 'APPROVE_STUDENT_REPORT_SUCCESS';
export const APPROVE_STUDENT_REPORT_FAILURE = 'APPROVE_STUDENT_REPORT_FAILURE';

export function approveStudentReport(progressReportId, studentReportId) {
  return (dispatch, getState) => {
    const userId = getState()
        .get('singleSignOn')
        .get('user')
        .get('profile')
        .sub;
    const url = buildUrl(`/unit-reports/${progressReportId}/dos-submits`);
    const method = 'PUT';

    return dispatch(approveStudentReportRequest()).payload
      .then((response) => dispatch(approveStudentReportSuccess(response)))
      // So that the report summary information gets updated
      .then(() => dispatch(fetchStudentReportSummaryIfNeeded(progressReportId, studentReportId)))
      .catch((error) => dispatch(approveStudentReportFailure(error)));

    function approveStudentReportRequest() {
      const payload = fetch(url, {
        method,
        body: JSON.stringify({
          studentReportId: Number.parseInt(studentReportId, 10),
          approvedBy: Number.parseInt(userId, 10),
        }),
      });

      return ApiCall.createAction({
        type: APPROVE_STUDENT_REPORT_REQUEST,
        payload,
        url,
        method,
        progressReportId,
        studentReportId,
      });
    }

    function approveStudentReportSuccess(payload) {
      return ApiCall.createAction({
        type: APPROVE_STUDENT_REPORT_SUCCESS,
        payload,
        progressReportId,
        studentReportId,
        url,
        method,
      });
    }

    function approveStudentReportFailure(error) {
      return ApiCall.createAction({
        type: APPROVE_STUDENT_REPORT_FAILURE,
        error,
        progressReportId,
        studentReportId,
        url,
        method,
      });
    }
  };
}



// WEBPACK FOOTER //
// ./data/ProgressReports/ApproveByDos/actions.js